import { useEffect, useRef } from "react";

let tabbyCardScriptPromise;

const loadTabbyCardScript = () => {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.TabbyCard) return Promise.resolve();
  if (!tabbyCardScriptPromise) {
    tabbyCardScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://checkout.tabby.ai/tabby-card.js";
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    }).catch((error) => {
      tabbyCardScriptPromise = null;
      throw error;
    });
  }
  return tabbyCardScriptPromise;
};

function TabbyCheckoutCard({ price, publicKey, merchantCode }) {
  const containerRef = useRef(null);
  const formattedPrice = Number(price).toFixed(2);

  useEffect(() => {
    if (!publicKey || !merchantCode || !Number.isFinite(Number(price)) || Number(price) <= 0) return undefined;
    let active = true;
    loadTabbyCardScript().then(() => {
      if (!active || !containerRef.current || !window.TabbyCard) return;
      containerRef.current.replaceChildren();
      new window.TabbyCard({
        selector: "#elumia-tabby-checkout-card",
        currency: "AED",
        price: formattedPrice,
        lang: "en",
        shouldInheritBg: true,
        publicKey,
        merchantCode,
      });
    }).catch(() => {
      // The payment option remains usable if the optional marketing snippet is unavailable.
    });
    return () => { active = false; };
  }, [formattedPrice, publicKey, merchantCode, price]);

  return <div id="elumia-tabby-checkout-card" ref={containerRef} aria-live="polite" />;
}

export default TabbyCheckoutCard;
